import IconButton from '@zenbusiness/zui/IconButton';
import { superstyled } from '@zenbusiness/zui/styles';

export const Root = superstyled({
  name: 'AppHeader',
  slot: 'Root',
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '1.5rem',
    justifyContent: 'space-between',

    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(1)
    }
  })
});

export const DrawerButton = superstyled({
  tag: IconButton,
  name: 'AppHeader',
  slot: 'DrawerButton',
  propsNeeded: ['open'],
  styles: ({ open, theme }) => ({
    color: 'inherit',
    display: 'none',
    justifySelf: 'start',
    order: 0,

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,

      '&:hover': {
        background: theme.palette.primary.main.darker
      },

      ...(open && {
        background: theme.palette.primary.main.light
      })
    }
  })
});

export const LogoContainer = superstyled({
  name: 'AppHeader',
  slot: 'LogoContainer',
  styles: ({ theme }) => ({
    display: 'none',
    order: 1,

    [theme.breakpoints.down('md')]: {
      display: 'block'
    }
  })
});

export const UserMenuContainer = superstyled({
  name: 'AppHeader',
  slot: 'UserMenu',
  styles: {
    order: 3
  }
});
